export const FORM_ID = {
  GP: 'FORM_TV_GP',
  AU: 'FORM_TV_AU',
};
export const CONFIRMATION_ID = {
  GP: 'CONFIRMATION_TV_GP',
  AU: 'CONFIRMATION_TV_AU',
};
export const CONFIRM_PATH = {
  dev: '/gp/tv/confirmacion/',
  qa: '/order/gp/tv/confirmacion/',
  prod: 'https://www.movistar.es/order/gp/tv/confirmacion/',
};
export const CONFIRM_PATH_AU = {
  dev: '/au/tv/confirmacion/',
  qa: '/order/au/tv/confirmacion/',
  prod: '/order/au/tv/confirmacion/',
};

export const URL_SEO = 'www.movistar.es/order/gp/tv';
export const PATH_NAME = {
  GP: '/order/gp/tv',
  AU: '/order/gp/tv',
};
export const NEXT_STEPS =
  'Te llamaremos en los próximos días para concertar una cita para la instalación.';

export const PHONE_900 = '900 110 619';
export const HOME_URL = 'https://www.movistar.es/internet/';

export const STUDENT_COOKIE = 'studentInfo';
export const TRANSACTION_TYPE = 'tv';
